import React from "react";

import BatchGroup, { BatchGroupProps } from "../../components/BatchGroup";
import TileGroup, { TileGroupProps } from "../../components/TileGroup";
import { Trans } from "react-i18next";
import { t } from "i18next";
import { Container, Row, Col } from "react-bootstrap";
import { DateRangePicker, DateInput, DateRangePickerChangeEvent, SelectionRange } from "@progress/kendo-react-dateinputs";
import { Button } from "@progress/kendo-react-buttons";
import { BatchService } from "../../services/BatchServices";
import TileService from "../../services/TileService";
import { useLoadingPanel } from "../../contexts/LoadingContext";
import { CommonLibrary } from "contexts/CommonContext";



function Dashboard() {

  const [tileData, setTileData] = React.useState<TileGroupProps>();
  const comonLibrary = new CommonLibrary();
  const [data, setData] = React.useState<BatchGroupProps>();
  const [selectedGroupId, setSelectedGroupId] = React.useState<string>('my_current_batches');
  const batchService = new BatchService();
  const tileService = new TileService();
  var loadingPanel = useLoadingPanel();

  const getStoredDate = (key: string, fallback: Date): Date => {
    const storedDate = comonLibrary.DashboardPeriodPersistence
      ? localStorage.getItem(`${comonLibrary.ProjectId}-${key}`) || sessionStorage.getItem(key)
      : sessionStorage.getItem(key);
    return storedDate ? new Date(storedDate) : fallback;
  };

  const startDate = () => getStoredDate("startDate", new Date(new Date().setDate(new Date().getDate() - 30)));
  const endDate = () => getStoredDate("endDate", new Date());
  const [valueDateRange, setValueDateRange] = React.useState<SelectionRange>({
    start: startDate(),
    end: endDate(),
  });

  const fetchData = async () => {
    loadingPanel.show("#root");
        
    if (comonLibrary.DashboardPeriodPersistence){
      setValueDateRange({
        start: localStorage.getItem(`${comonLibrary.ProjectId}-startDate`) ? new Date(localStorage.getItem(`${comonLibrary.ProjectId}-startDate`) as string) : valueDateRange.start,
        end: localStorage.getItem(`${comonLibrary.ProjectId}-endDate`)? new Date(localStorage.getItem(`${comonLibrary.ProjectId}-endDate`) as string):valueDateRange.end,
      });
    }
    saveDateRange();
    
    batchService.GetBatchGroup({ startDate: valueDateRange.start?? new Date(), endDate: valueDateRange.end?? new Date() })
      .then((result)=> {    
        setData({ BatchGroups: result, onTabSelect: handleTabSelect, onReleaseBatch});
        fetchTiles();  
      }).finally(()=>{
        loadingPanel.hide();
      });
    
  };
  const saveDateRange = () => {
    sessionStorage.setItem("startDate", valueDateRange.start?.toDateString() ?? new Date().toDateString());
    sessionStorage.setItem("endDate", valueDateRange.end?.toDateString() ?? new Date().toDateString());
  }
  
  const fetchTiles = async () => {
    const tiles = await tileService.GetTiles( valueDateRange.start?? new Date(), valueDateRange.end?? new Date());
    setTileData({TileGroups: tiles});
  }

  const CustomStartDateInput = (props: any) => {
    return (
      <label style={{ textAlign: "center" }}>
        <DateInput {...props} label={undefined} placeholder={t("general.start")}  value={props.start} />
      </label>
    );
  };

  const CustomEndDateInput = (props: any) => {
    return (
      <label style={{ textAlign: "center" }}>
        <DateInput {...props} label={undefined} placeholder={t("general.end")} value={props.end}/>
      </label>
    );
  };

  React.useEffect(() => {
    fetchData();
    
  }, []);

  const handleDateRangeChange = (event: DateRangePickerChangeEvent) => {
    setValueDateRange(event.value);
    if(comonLibrary.DashboardPeriodPersistence){
      localStorage.setItem(`${comonLibrary.ProjectId}-startDate`, event.value.start?.toDateString() ?? new Date().toDateString());
      localStorage.setItem(`${comonLibrary.ProjectId}-endDate`, event.value.end?.toDateString() ?? new Date().toDateString());
    }
  }


  const handleTabSelect = (groupId: string) => {
    setSelectedGroupId(groupId);
    loadBatches(groupId);
  }

  const loadBatches = async (groupId: string) => {
    const result = await batchService.GetBatches({ 
      startDate: valueDateRange.start? valueDateRange.start : new Date(), 
      endDate: valueDateRange.end? valueDateRange.end : new Date()
      , groupId: groupId });
    data?.BatchGroups?.filter((x) => x.GroupId === groupId).forEach((x) => {
      x.Batches = result.Batches;
      x.NumberOfItems = result.NumberOfItems;
      x.NumberOfDocuments = result.NumberOfDocuments;
    });
    const d = { BatchGroups: data?.BatchGroups, onTabSelect: handleTabSelect, onReleaseBatch};
    setData(d);
    
  }

  const onReleaseBatch = () => {
    loadBatches(selectedGroupId);
  }

  return (
    <div>
      <div className="filter-container">
        <Container>
          <div>
            <Row className="filter-content">
              <Col md={1} className="pt-1">
                <span><Trans>general.dateFilter</Trans></span>
              </Col>
              <Col md={4}>
                <form className="k-form" onSubmit={(e) => e.preventDefault()}>
                  <DateRangePicker
                    clearButton={true}
                    format={"dd-MMM-yyyy"}
                    startDateInput={(props) => (
                      <CustomStartDateInput {...props} {...valueDateRange} />
                    )}
                    endDateInput={(props) => (
                      <CustomEndDateInput {...props} {...valueDateRange} />
                    )}
                    onChange={handleDateRangeChange}
                    
                  />
                </form>
              </Col>
              <Col md={2}>
                <div className="float-right">
                  <Button title={t("general.apply")} themeColor={"primary"} type="button" onClick={fetchData} ><Trans>general.apply</Trans></Button>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <div>
        <div className="pt-6">
          <TileGroup TileGroups={tileData?.TileGroups} />
        </div>
        <div className="pt-4">
          <div className="tile-content">
            <BatchGroup BatchGroups={data?.BatchGroups} onTabSelect={handleTabSelect} onReleaseBatch={onReleaseBatch} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;